module.exports = __webpack_public_path__ + "open-sans-latin-800italic.ca67d5b14355e769f10f.svg";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-800italic.svg
// module id = ../../../../typeface-open-sans/files/open-sans-latin-800italic.svg
// module chunks = 1 3